<template>
  <v-simple-table>
    <template>
      <thead style="background-color: #f8f8f8">
        <tr>
          <th class="text-subtitle-2 text-center" style="width: 5%">ID</th>
          <th class="text-subtitle-2 text-left" style="width: 45%">Tên</th>
          <th class="text-subtitle-2 text-center" style="width: 30%">
            <div class="d-flex align-center justify-center">
              Trạng thái đi học
              <v-checkbox
                v-model="statusAll"
                class="ml-2 mt-0"
                hide-details
                dense
                @change="toggleAllAttendance"
              ></v-checkbox>
            </div>
          </th>
          <th v-if="isHybrid" class="text-subtitle-2 text-center" style="width: 20%">Online</th>
        </tr>
      </thead>
      <tbody v-if="data.length">
        <tr v-for="(item, index) in data" :key="item.id">
          <td class="text-center">{{ index + 1 }}</td>
          <td>
            <div class="text-none text-decoration-none primary--text">
              {{ item.student.name }}
            </div>
          </td>
          <td class="text-center">
            <v-chip
              :color="item.isAttended ? 'success' : 'error'"
              small
              @click="toggleAttendance(item)"
            >
              {{ item.isAttended ? 'Đi học' : 'Vắng mặt' }}
            </v-chip>
          </td>
          <td v-if="isHybrid" class="text-center">
            <v-icon
              :color="item.isOnline ? 'success' : 'grey lighten-1'" 
              @click="toggleOnline(item)"
              size="20"
              class="transition-swing"
            >
              {{ item.isOnline ? 'mdi-wifi' : 'mdi-wifi-off' }}
            </v-icon>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="4">
            <div class="d-flex flex-column align-center py-4">
              <div class="mb-2">Chưa có dữ liệu học sinh trong lớp</div>
              <v-btn
                color="primary"
                text
                @click="$router.push(`/class/${classData.id}`)"
              >
                <v-icon left>mdi-plus</v-icon>
                Thêm học viên
              </v-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/plugins/utils.js'
import get from 'lodash-es/get'
export default {
  props: {
    isStatusShown: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusAll: false,
      data: [],
    }
  },
  computed: {
    ...mapState({
      isHybrid(state) {
        return get(state['class'].clazz, 'metadata.classMode') === 'hybrid'
      },
      attendances(state) {
        return state['lessonAttendance'].attendances.filter(att => att.student.status === 'active')
      },
      classData(state) {
        return state['class'].clazz
      },
      originList() {
        return this.attendances.map((s) => ({
          ...s,
          isAttended: s.status === 'attended',
          isOnline: s.isOnline,
          tags: utils.clearUnicodeWithDivider(s.name),
        }))
      },
    }),
  },
  methods: {
    toggleAllAttendance(value) {
      this.data.forEach(item => {
        item.isAttended = value
      })
    },
    toggleAttendance(item) {
      item.isAttended = !item.isAttended
      this.statusAll = this.data.every(item => item.isAttended)
    },
    toggleOnline(item) {
      item.isOnline = !item.isOnline  
    },
    getData() {
      return this.data
    },
    handleSearch(search) {
      if (typeof search === 'string' && search.length) {
        this.data = this.originList.filter((x) => x.tags.includes(search))
      } else {
        this.data = [...this.originList]
      }
    },
  },
  watch: {
    originList: {
      handler(val) {
        if (val) {
          this.data = val
          this.statusAll = this.data.every(item => item.isAttended)
        }
      },
      immediate: true,
      deep: true,
    },
    search: {
      handler(val) {
        this.handleSearch(val)
      },
      immediate: true,
    },
  },
}
</script>
